import CashRegisterUpdate from './CashRegisterUpdate'
export {CashRegisterUpdate}
export default CashRegisterUpdate
